module.exports = __webpack_public_path__ + "static/media/PoweredByAglive.c202d6f9.png";